// extracted by css-extract-rspack-plugin
export default {"cls1":"FocusedNavView-cls1_Tjv","cls2":"FocusedNavView-cls2_4Xf FocusedNavView-cls1_Tjv"};